/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Row, Col } from 'antd';

import { Select, Button } from '@atoms';
import { useModalControls } from '@hooks';

const ContentModulePicker = ({
  style,
  contentModules,
  onSubmit,
  allowAdd,
  defaultOpenedType,
  buttonLabel = 'ADD RELATED CONTENT',
  buttonType = 'customBlue',
  placeholder = '- Choose a type of content -',
  eventBlogsList,
}) => {
  const modalControls = useModalControls();
  const [contentModuleIndex, setContentModuleIndex] = React.useState(undefined);

  React.useEffect(() => {
    const index = contentModules.findIndex(({ type }) => type === defaultOpenedType);
    if (index !== -1) {
      setContentModuleIndex(index);
      modalControls.show();
    }
    // Listen only for these dependencies. If modalControls is added then it will always trigger useEffect
    // when modal closes and reopen it again
  }, [contentModules, defaultOpenedType]); // eslint-disable-line react-hooks/exhaustive-deps

  const contentModule = React.useMemo(() => contentModules[contentModuleIndex], [contentModules, contentModuleIndex]);

  const renderModal = () => {
    if (!contentModule) return null;

    const { modal: ContentModuleModal, type: manualType, ...moduleConfig } = contentModule;

    return (
      <ContentModuleModal
        {...modalControls}
        {...moduleConfig}
        onSubmit={(content, type = manualType) => onSubmit({ type, content })}
        eventBlogsList={eventBlogsList}
      />
    );
  };

  const handleAddModule = React.useCallback(async () => {
    // If no allowAdd - always open modal
    const allowed = allowAdd ? await allowAdd(contentModule || {}) : true;

    if (allowed) modalControls.show();
  }, [allowAdd, contentModule, modalControls]);

  return (
    <>
      <Row align="middle" gutter={20} style={{ ...style, flexWrap: 'nowrap' }}>
        <Col flex="1">
          <Select
            value={contentModuleIndex}
            placeholder={placeholder}
            onSelect={setContentModuleIndex}
            style={{ width: '100%' }}
          >
            {contentModules.map(({ label }, idx) => (
              <Select.Option key={idx} value={idx}>
                {label}
              </Select.Option>
            ))}
          </Select>
        </Col>
        <Col flex="0 0 auto">
          <Button type={buttonType} disabled={contentModuleIndex === undefined} onClick={handleAddModule}>
            {buttonLabel}
          </Button>
        </Col>
      </Row>
      {renderModal()}
    </>
  );
};

export default ContentModulePicker;
